import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function PreviewCarousel() {
  const images = ['https://cdn.magicpatterns.com/uploads/ceXATDa4MDuad25DM8RXSA/IMG_5054_3.jpg', 'https://cdn.magicpatterns.com/uploads/koYjmfcWyj392kGgmdTUgs/IMG_5055_3.jpg', 'https://cdn.magicpatterns.com/uploads/5tYPN7Q21dWaey2Gp6dtGx/IMG_5056_3.jpg'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="py-16 px-4 bg-[#f8f9fa] overflow-hidden" data-id="element-99">
      <div className="max-w-4xl mx-auto text-center" data-id="element-100">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl mb-10 uppercase text-[#1a3d1f]" data-id="element-101">
          Un vistazo al contenido del ebook👀
        </motion.h2>

        <div className="relative max-w-md mx-auto" data-id="element-102">
          <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-103">
            <img src={images[currentIndex]} className="w-full h-auto block cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
            behavior: 'smooth'
          })} alt={`Vista previa ${currentIndex + 1}`} data-id="element-104" />
          </div>

          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 md:-translate-x-full bg-[#84cc16] text-[#14321a] p-2 rounded-full shadow-lg z-10 hover:bg-[#65a30d] transition-colors" aria-label="Imagen anterior" data-id="element-105">
            <ChevronLeft className="w-6 h-6" data-id="element-106" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 md:translate-x-full bg-[#84cc16] text-[#14321a] p-2 rounded-full shadow-lg z-10 hover:bg-[#65a30d] transition-colors" aria-label="Imagen siguiente" data-id="element-107">
            <ChevronRight className="w-6 h-6" data-id="element-108" />
          </button>

          <div className="flex justify-center mt-6 gap-2" data-id="element-109">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-3 h-3 rounded-full transition-colors ${idx === currentIndex ? 'bg-[#84cc16]' : 'bg-[#1a3d1f]/20'}`} aria-label={`Ir a la imagen ${idx + 1}`} data-id="element-110" />)}
          </div>
        </div>
      </div>
    </section>;
}